import script from "./AnimationPushToShadow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnimationPushToShadow.vue?vue&type=script&lang=ts&setup=true"

import "./AnimationPushToShadow.vue?vue&type=style&index=0&id=d20cf66e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d20cf66e"]])

export default __exports__